import React from 'react';
import styles from './Header.module.css';
import {Container, Nav, Navbar, Button} from 'react-bootstrap';
import {Favorite, Logout} from '@mui/icons-material';

function Header() {
    return (
        <Navbar collapseOnSelect expand="xl">
            <Container>
                <Navbar.Brand href="#home">LOGO</Navbar.Brand>
                <Nav>
                    <Nav.Link href="#business">Business</Nav.Link>
                    <Nav.Item href="#new">
                        <Button
                            className={`${styles.newBtn} mt-2`}
                            size="sm">New
                        </Button></Nav.Item>
                    {/*<Nav.Link eventKey={2} href="#memes">*/}
                    <Nav.Link>|</Nav.Link>
                    <Nav.Link className='trips' href="#trips">Trips</Nav.Link>
                    <Nav.Link href="#favorite"><Favorite/></Nav.Link>
                    <Nav.Link className={styles.logout} href="#logout"><Logout/> Logout</Nav.Link>
                    <Nav.Link href="#lang">
                        <select id="Lang" className={`${styles.selectOption}`}>
                            <option value="eng">ENG</option>
                            <option value="bd">BD</option>
                        </select>
                    </Nav.Link>
                </Nav>
                {/*</Navbar.Collapse>*/}
            </Container>
        </Navbar>
    );
}

export default Header;
